import { createRouter,createWebHashHistory } from 'vue-router';
import main from "@/layout/main.vue";

import { useUserStore } from '@/store/login'

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            name: '',
            path: '/',
            component: main,
            children:[
                {
                    name: 'index',
                    path: '/',
                    component: ()=>import('@/pages/index.vue'),
                },
                {
                    name: 'notice',
                    path: '/notice',
                    component: ()=>import('@/pages/notice/index.vue'),
                    children:[
                        {
                            name: 'notice-detail',
                            path: 'detail',
                            component: ()=>import('@/pages/notice/detail.vue'),
                        }
                    ]
                },
                {
                    name: 'school',
                    path: '/school',
                    component: ()=>import('@/pages/school/index.vue'),
                    children:[
                        {
                            name: 'school-detail',
                            path: '/school/detail',
                            component: ()=>import('@/pages/school/detail.vue'),
                        }
                    ]
                },
                {
                    name: 'login',
                    path: '/login',
                    component: ()=>import('@/pages/login.vue'),
                },
                {
                    name: 'policy',
                    path: '/policy',
                    component: ()=>import('@/pages/policy/index.vue'),
                    children:[
                        {
                            name: 'policy-detail',
                            path: '/policy/detail',
                            component: ()=>import('@/pages/policy/detail.vue'),
                        }
                    ]
                },
                {
                    name: 'myapply',
                    path: '/myapply',
                    component: ()=>import('@/pages/myapply/index.vue'),
                    redirect:'/myapply/lookbm/myreport',
                    children:[
                        {
                            name: 'bm',
                            path: '/myapply/bm',
                            component: ()=>import('@/pages/myapply/bm/index.vue'),
                            redirect:'/myapply/bm/baoming',
                            children:[
                                {
                                    name: 'baoming',
                                    path: '/myapply/bm/baoming',
                                    component: ()=>import('@/pages/myapply/bm/child/baoming.vue'),
                                },
                                {
                                    name: 'FillInInformation',
                                    path: '/myapply/bm/FillInInformation',
                                    component: ()=>import('@/pages/myapply/bm/child/FillInInformation.vue'),
                                },
                                {
                                    name: 'loginbaoming',
                                    path: '/myapply/bm/loginbaoming',
                                    component: ()=>import('@/pages/myapply/bm/child/loginbaoming.vue'),
                                },
                                {
                                    name: 'result',
                                    path: '/myapply/bm/result',
                                    component: ()=>import('@/pages/myapply/bm/child/result.vue'),
                                }
                            ]
                        },
                        {
                            name: 'lookbm',
                            path: '/myapply/lookbm',
                            component: ()=>import('@/pages/myapply/lookbm/index.vue'),
                            redirect:'/myapply/lookbm/myreport',
                            
                            children:[
                                {
                                    name: 'myreport',
                                    path: '/myapply/lookbm/myreport',
                                    component: ()=>import('@/pages/myapply/lookbm/child/myreport.vue'),
                                   
                                },
                                {
                                    name: 'updatepassword',
                                    path: '/myapply/lookbm/updatepassword',
                                    component: ()=>import('@/pages/myapply/lookbm/child/updatepassword.vue'),
                                    
                                },
                                {
                                    name: 'exit',
                                    path: '/myapply/lookbm/exit',
                                    component: ()=>import('@/pages/myapply/lookbm/child/exit.vue'),
                                    
                                }
                            ]
                        }
                    ]
                }
            ],
        },
        {
            path: '/:pathMathc(.*)',
            redirect: '/',
        }
    ],
})

router.beforeEach((to) => {
    const loginStore= useUserStore()
    if (to.query.acid) {
        loginStore.setAcid(to.query.acid)
    }
    if (loginStore.acid && !to.query.acid) {
        return {
            path: to.path,
            query: {
                ...to.query,
                acid: loginStore.acid
            }
        }
    }
    // if (!to.query.acid && !loginStore.acid && to.name !== 'login') {
    //     return { name: 'login' }
    // }
    return true
})
router.beforeEach((to,from,next)=>{
    if(from.path=='/myapply/bm/result'){
      if(confirm('系统不会保存您的数据，确认离开此页面')){
        next()
      }
    }else{
      next()
    }
})
export default router